import axios from 'axios';

export default axios.create({
    baseURL: (window.location.origin).includes('localhost') ? 'http://localhost:8085/api' : `${window.location.origin}/api`,
    timeout: 60000,
    maxContentLength: 50 * 1000 * 1000,
    headers: {},
});
